var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoTransactionRestriction = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.87499 4.603C6.7863 3.95077 7.87933 3.601 8.99999 3.603C9.99143 3.60122 10.9642 3.87278 11.8113 4.38784C12.6585 4.90289 13.3473 5.64152 13.802 6.52253C14.2567 7.40355 14.4598 8.39287 14.3888 9.38177C14.3179 10.3707 13.9758 11.3209 13.4 12.128L5.87499 4.603Z",
    fill: "#00AABE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60298 5.875L12.122 13.394C11.2107 14.0462 10.1177 14.396 8.997 14.394C8.00568 14.3964 7.03291 14.1253 6.18579 13.6104C5.33868 13.0955 4.65007 12.3568 4.19577 11.4758C3.74147 10.5947 3.53912 9.60529 3.61096 8.61658C3.68281 7.62787 4.02608 6.67815 4.60298 5.872V5.875Z",
    fill: "#00AABE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9C0 10.78 0.527837 12.5201 1.51677 14.0001C2.5057 15.4802 3.91131 16.6337 5.55585 17.3149C7.20038 17.9961 9.00998 18.1743 10.7558 17.8271C12.5016 17.4798 14.1053 16.6226 15.364 15.364C16.6226 14.1053 17.4798 12.5016 17.8271 10.7558C18.1743 9.00998 17.9961 7.20038 17.3149 5.55585C16.6337 3.91131 15.4802 2.50571 14.0001 1.51677C12.5201 0.527841 10.78 0 9 0C6.61305 0 4.32386 0.948211 2.63603 2.63604C0.948205 4.32387 0 6.61305 0 9ZM1.8 9C1.8 7.57597 2.22227 6.18393 3.01341 4.99989C3.80456 3.81586 4.92905 2.89302 6.24467 2.34807C7.5603 1.80312 9.00798 1.66053 10.4046 1.93835C11.8013 2.21616 13.0842 2.90189 14.0912 3.90883C15.0981 4.91577 15.7838 6.19869 16.0617 7.59535C16.3395 8.99201 16.1969 10.4397 15.6519 11.7553C15.107 13.0709 14.1841 14.1954 13.0001 14.9866C11.8161 15.7777 10.424 16.2 9 16.2C7.09125 16.1974 5.26144 15.4379 3.91175 14.0882C2.56206 12.7386 1.80264 10.9087 1.8 9Z",
    fill: "#00AABE"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoTransactionRestriction);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_transaction_restriction.3ba4ba1407ee3ba22d9f86cda90c26b8.svg";